<template>
    <div>
        <ShowDetails :animalId="animalId" />
    </div>
</template>

<script>
import ShowDetails from '@/components/animal/ShowDetails.vue'
export default {
    components: {
        ShowDetails
    },
    computed: {
        animalId() {
            return Number(this.$route.params.id); // URL'den gelen id'yi al
        }
    },
    name: 'AnimalDetail',
}
</script>